import { useQueryClient, useMutation } from "@tanstack/react-query";
import { deleteSurvey } from "./useDeleteSurvey.query";
import { useDeleteSurveyProps } from "./useDeleteSurvey.types";

export function useDeleteSurvey() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ["survey_delete"],
        mutationFn: async (survey_id: useDeleteSurveyProps) => {
            const res = await deleteSurvey(survey_id);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["surveys"]})
            queryClient.invalidateQueries({queryKey: ["survey"],exact: false});
        }
    });
}
